import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-section1',
  templateUrl: './section1.component.html',
  styleUrls: ['./section1.component.scss']
})
export class Section1Component implements OnInit {
  checkPhoneReq: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    // console.log(control.value);
    // console.log(this.basicData.controls.personalMobile1.value);
    let phone1 = group.get('liveWithMobile1')?.value;
    let phone2 = group.get('liveWithMobile2')?.value;
    console.log("live with"+group.get('liveWith')?.value );
    console.log("phone1"+phone1);
    console.log("phone2"+phone2 );
    if (group.get('liveWith')?.value === 10){
      return  (phone1.length==0 || phone2.length==0)? { reqPhone: true } : null
    }else if (group.get('liveWith')?.value === 40){
      return  (phone1.length==0 )? { reqPhone: true } : null
    }else{
      return  (phone1.length==0 && phone2.length==0)? { reqPhone: true } : null
    }
    // let phone1 = "";
    // let phone2 = "";
    // console.log("phone1:" + phone1);
    // console.log("phone2:" + phone2);

   // return phone1 && phone2 && phone1 === phone2 ? { samePhone: true } : null
  }
  currentDate = new Date();
  showLoader: boolean = false;
  creating: boolean = false;
  url: string = "";
  imageUrl: any = "https://gravatar.com/avatar/ae4e3e608c9496ff0a04d46b0304cbe8?s=400&d=robohash&r=x";
  uploadImage: any;
  questionData: any;
  showQuestion = false;
  livewith: any;
  numberOfQuestions: any;
  updateQuestionCounter = 0;
  candidateOrderINFamily = new Array(1);
  // questionDataTest: any;
  // allQuestionsData: any;

  selectOther: boolean = false;
  selectBoth: boolean = false;
  selectOne: boolean = false;
  selectGrand: boolean = false;
  liveWithMobile1:string="";
  liveWithMobile2:string="";

  section1Data = new FormGroup({
    candCode: new FormControl(''),
    liveWith: new FormControl('', [
      Validators.required,
    ]),
    liveWithOther: new FormControl('', [
      // Validators.required,
    ]),
    liveWithMobile1: new FormControl('', [
     // Validators.required,
      Validators.maxLength(11),
      Validators.minLength(11),
      Validators.pattern('[0][1](1|2|5|0)[0-9]{8}'),
    ]),
    liveWithMobile2: new FormControl('', [
      //Validators.required,
      Validators.maxLength(11),
      Validators.minLength(11),
      Validators.pattern('[0][1](1|2|5|0)[0-9]{8}'),
    ]),
    // liveWithContact1: new FormControl('', [
    //   Validators.required,
    // ]),
    // liveWithContact2: new FormControl('', [
    //   // Validators.required,
    // ]),
    siblingsCount: new FormControl('', [
      Validators.required, Validators.pattern("^[0-9]*$"),
    ]),
    candSiblingsRank: new FormControl('', [
      Validators.required,
    ]),

  },this.checkPhoneReq);
  constructor(public globals: Globals, private toastr: ToastrService,
    public activatedRoute: ActivatedRoute, public router: Router, public admService: AdmService,
    public translate: TranslateService) { }

  ngOnInit(): void {
    this.getAllLivewith();
    this.getCandidateQuestions();
    this.getCandById(this.globals.candidateId);

  }
  getAllLivewith() {
    this.admService.getAllLiveWith()
      .subscribe(
        data => {
          this.livewith = data;
        },
        error => {
          this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        }
      );
  }
  section1DataChange() {
    console.log(this.section1Data.controls.siblingsCount.value);
    if (this.section1Data.controls.siblingsCount.value != null) {
      let a = this.section1Data.controls.siblingsCount.value;
      this.candidateOrderINFamily = new Array(Number(a) + 1);
    }

  }

  section1DataSubmit() {
    // this.creating = true;
    // console.log("befor valid");
    if (this.section1Data.valid) {

      console.log("in valid");
      this.creating = true;
      this.admService.addSection1CandData(this.globals.candidateId,
        this.section1Data.controls.liveWith.value,
        this.section1Data.controls.liveWithOther.value,
        this.section1Data.controls.liveWithMobile1.value,
        this.section1Data.controls.liveWithMobile2.value,
        "",
        "",
        this.section1Data.controls.siblingsCount.value,
        this.section1Data.controls.candSiblingsRank.value,
        this.currentDate
      )
        .subscribe(
          data => {
            this.questionData.forEach((question: any) => {
              console.log(question.candQuesId);
              console.log(this.section1Data.get(question.formControlName)?.value);
              this.updateCanditeAnsu(question.candQuesId, this.section1Data.get(question.formControlName)?.value)
            });
          },
          error => {
            this.creating = false
            this.toastr.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
          },
          () => this.creating = false
        );
    }
    else {
      console.log("non valid");
      this.section1Data.markAllAsTouched();
      this.section1Data.markAsDirty();
      this.creating = false;
    }
  }
  updateCanditeAnsu(id: any, quesValue: String) {
    this.admService.updateCanditeAnsu(id, quesValue)
      .subscribe(
        data => {
          this.updateQuestionCounter++;
          if (this.updateQuestionCounter == this.numberOfQuestions) {
            this.toastr.success(this.translate.instant('UPDATED_SUCCESSFULLY'));
            this.router.navigate(['/admission/section2']);
          }
        },
        error => {
          this.creating = false
          this.toastr.error(`can't Save answer for question#${this.updateQuestionCounter}`);
        },
        () => this.creating = false
      );

  }
  getCandidateQuestions() {
    this.showLoader = true;
    let secNumber = 2;
    this.admService.getQuestionByCandidateAndSec(this.globals.candidateId, secNumber).subscribe(
      data => {
        this.questionData = data.map((question: any) => {

          return { candQuesId: question.id, id: question.questionid, questionDescAr: "", questionDescEn: "", questionType: "", values: [], formControlName: "" };
        });
        // Get number of candidate questions
        this.numberOfQuestions = this.questionData.length;
        this.showQuestion = true;
        this.questionData.forEach((element: any) => {
          this.getQuestionById(element.id);
        });
        this.questionData = this.questionData;
      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }
  getQuestionById(questionId: number) {
    this.admService.getQuestionById(questionId).subscribe(
      data => {
        this.questionData = this.questionData.map((question: any) => {
          if (question.id == questionId) {
            if (data.questionType == "LIST") {
              this.getQuestionListAnswerData(questionId);
            }
            let formControlName = "candidate_question_" + questionId;
            if (data.requiredFlag === 'YES') {
              this.section1Data.addControl(formControlName, new FormControl("", Validators.required));
            } else {
              this.section1Data.addControl(formControlName, new FormControl(""));
            }
            return { candQuesId: question.candQuesId, id: data.id, questionDescAr: data.questionDescAr, questionDescEn: data.questionDescEn, questionType: data.questionType, values: question.values, formControlName: formControlName };
          } else {
            return question
          }
        });
      },
      error => {
        this.toastr.error(`can't get question#${questionId}`);
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }

  getQuestionListAnswerData(questionId: number) {
    let orgNumber = this.globals.orgId;
    this.admService.getQuestionListAnswerData(orgNumber, questionId).subscribe(
      data => {
        this.questionData = this.questionData.map((question: any) => {
          if (question.id == questionId) {
            question.values = data;
            return question;
          } else {
            return question;
          }
        });
        console.log(this.questionData);
      },
      error => {
        this.toastr.error(`can't get question#${questionId} values`);
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }
  isTouched(formControlName: string): boolean {
    return this.section1Data.get(formControlName)?.touched ? true : false;
  }

  isInvalid(formControlName: string): boolean {
    return this.section1Data.get(formControlName)?.invalid ? true : false;
  }
  liveWith() {
    if (this.section1Data.controls.liveWith.value === 40) {
      this.section1Data.controls.liveWithOther.setValidators([Validators.required]);
      // this.section1Data.controls.liveWithMobile1.setValidators([Validators.required,Validators.maxLength(11),Validators.minLength(11),Validators.pattern('[0][1](1|2|5|0)[0-9]{8}')]);
      // this.section1Data.controls.liveWithMobile2.setValidators([Validators.maxLength(11),Validators.minLength(11),Validators.pattern('[0][1](1|2|5|0)[0-9]{8}')]);
      this.section1Data.controls.liveWithOther.updateValueAndValidity();
      this.selectOther=true;
      this.selectBoth = false;
      this.selectOne = false;
      this.selectGrand = false;
    } else if(this.section1Data.controls.liveWith.value === 10) {
      this.section1Data.controls.liveWithOther.setValidators(null);
      // this.section1Data.controls.liveWithMobile1.setValidators([Validators.required,Validators.maxLength(11),Validators.minLength(11),Validators.pattern('[0][1](1|2|5|0)[0-9]{8}')]);
      // this.section1Data.controls.liveWithMobile2.setValidators([Validators.required,Validators.maxLength(11),Validators.minLength(11),Validators.pattern('[0][1](1|2|5|0)[0-9]{8}')]);
      this.section1Data.controls.liveWithOther.updateValueAndValidity();
      this.selectOther=false;
      this.selectBoth = true;
      this.selectOne = false;
      this.selectGrand = false;

    } else if(this.section1Data.controls.liveWith.value === 20) {
      this.section1Data.controls.liveWithOther.setValidators(null);
      this.section1Data.controls.liveWithOther.updateValueAndValidity();
      this.selectOther=false;
      this.selectBoth = false;
      this.selectOne = true;
      this.selectGrand = false;

    } else if(this.section1Data.controls.liveWith.value === 30) {
      this.section1Data.controls.liveWithOther.setValidators(null);
      this.section1Data.controls.liveWithOther.updateValueAndValidity();
      this.selectOther=false;
      this.selectBoth = false;
      this.selectOne = false;
      this.selectGrand = true;

    }else{
      this.toastr.warning("Please Select A vaild live with ..");
    }


  }

  getCandById(candId: number) {
    this.admService.getCandidateById(candId).subscribe(
      data => {
        this.section1Data.controls.candCode.setValue(data.candCode);
      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
      }
    );
  }

}
